export default __webpack_public_path__ + "static/media/alcohol.348d0242.svg";